// @ts-nocheck

import { createContext } from 'react';

import { SportId } from '../types/sports';

type MatchRouteContextProps = {
  matchId?: number;
  sportId?: SportId;
};

export const MatchRouteContext = createContext<MatchRouteContextProps>({});
